/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SafetyWarning
 */
export interface SafetyWarning {
    /**
     * 
     * @type {string}
     * @memberof SafetyWarning
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SafetyWarning
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SafetyWarning
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SafetyWarning
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SafetyWarning
     */
    severity?: string;
    /**
     * 
     * @type {Date}
     * @memberof SafetyWarning
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SafetyWarning
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyWarning
     */
    active?: boolean;
}

/**
 * Check if a given object implements the SafetyWarning interface.
 */
export function instanceOfSafetyWarning(value: object): value is SafetyWarning {
    return true;
}

export function SafetyWarningFromJSON(json: any): SafetyWarning {
    return SafetyWarningFromJSONTyped(json, false);
}

export function SafetyWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafetyWarning {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function SafetyWarningToJSON(value?: SafetyWarning | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'title': value['title'],
        'description': value['description'],
        'severity': value['severity'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'active': value['active'],
    };
}

